<div class="main-modal-bg">
  <div class="inner-frame-bg inner-frame-tablet">
    <div class="preview-container-tablet">
      <figure class="figure-tablet">
        <svg class="tablet-shell-svg" viewBox="0 0 100% 100%" aria-hidden="true" focusable="false">
          <defs>
            <linearGradient id="tabletEdgeGlow" gradientTransform="rotate(90)">
              <stop offset="0%" stop-color="#649cfa"></stop>
              <stop offset="55%" stop-color="#4285f4"></stop>
              <stop offset="80%" stop-color="#2b67c6"></stop>
              <stop offset="100%" stop-color="#144496"></stop>
            </linearGradient>
            <radialGradient id="tabletGlass" cx="50%" cy="10%" r="88%">
              <stop offset="0%" stop-color="#5f7dcb" stop-opacity="0.2"></stop>
              <stop offset="55%" stop-color="#2e3f6d" stop-opacity="0.05"></stop>
              <stop offset="100%" stop-color="#0a1020" stop-opacity="0"></stop>
            </radialGradient>
          </defs>
          <rect class="tablet-outer" x="0" y="0" width="1560" height="1000" rx="30"></rect>
          <rect class="tablet-outer-highlight" x="5" y="5" width="1532" height="972" rx="25"></rect>
          <rect class="tablet-screen-border" x="30" y="30" width="1384" height="824" rx="20"></rect>
          <rect class="tablet-screen-glass" x="30" y="30" width="1384" height="824" rx="20"></rect> 
        </svg>
        <div class="tablet-content">
          <iframe [src]="iframeSrc" allowfullscreen="" loading="lazy" class="tablet-iframe" id="tablet-iframe"></iframe>
        </div>
      </figure>
    </div>
  </div>
</div>
<div class="tablet-shadow"></div>
<div class="screen-shadow"></div>
